var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareRoot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 40C576 62.092 558.092 80 536 80H350.938L246.719 482.031C242.594 497.969 229.125 509.75 212.781 511.719C211.188 511.906 209.594 512 208 512C193.406 512 179.812 504.031 172.781 490.969L72.094 304H40C17.908 304 0 286.092 0 264S17.908 224 40 224H96.008C110.721 224 124.244 232.078 131.219 245.031L194.875 363.25L281.281 29.969C285.855 12.322 301.781 0 320.01 0H536C558.092 0 576 17.908 576 40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareRoot);
export default __webpack_public_path__ + "static/media/square-root.3b586c737b5779479dbbfdd38eeb5958.svg";
export { ForwardRef as ReactComponent };